import {isSupportedCountry, parsePhoneNumber} from 'libphonenumber-js';

import {isEmpty, isNil} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

export function formatPhoneNumber(
  phoneNumber: string | Nullish,
  defaultCountry?: string | Nullish
): string | null {
  if (isNil(phoneNumber) || isEmpty(phoneNumber)) {
    return null;
  }

  const countryCode =
    isNotNil(defaultCountry) && isSupportedCountry(defaultCountry) ? defaultCountry : undefined;

  try {
    return parsePhoneNumber(phoneNumber, countryCode)?.formatInternational() ?? phoneNumber;
  } catch {
    return phoneNumber;
  }
}
